export default "__VITE_ASSET__3539173c__"